import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DropdownButtonItem } from './dropdown-button-item';
import { BaseButtonComponent } from '../base-button/base-button.component';

@Component({
  selector: 'app-dropdown-button',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule],
  templateUrl: './dropdown-button.component.html',
  styleUrls: [
    '../base-button/base-button.component.scss',
    '../primary-button/primary-button.component.scss',
    './dropdown-button.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownButtonComponent extends BaseButtonComponent {
  @Input() dropdownItems: DropdownButtonItem[] = [];
  @Input() itemAlign: 'start' | 'end' = 'end';
  @Input() menuMaxHeight: string | null = '9rem';
  @Output() itemSelected = new EventEmitter<DropdownButtonItem>();

  public isDropdownOpen = false;
}
